import "./App.scss";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { Provider as ReduxProvider } from "react-redux";

import i18n from "./i18n";
import App from "./routes/routes";
import { persistor, store } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import LoadingComponent from "./components/LoadingComponent/LoadingComponent";

ReactDOM.render(
  <ReduxProvider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename="/">
          <App />
          <LoadingComponent />
        </BrowserRouter>
      </I18nextProvider>
    </PersistGate>
  </ReduxProvider>,
  document.getElementById("root"),
);
